import React from 'react';
import ReactDOM from 'react-dom';
import App from './App/App';
import './fonts/NewStandartOld.ttf';
import './fonts/NewStandartOld.woff';

ReactDOM.render(

        <App />
,
  document.getElementById('root') as HTMLElement
);

